// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Response Code Section Styles */
.response-code-section {
  display: flex;
  flex-direction: column;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #ffffff;
  overflow: hidden;
  flex: 1;
}

.response-code-section .code-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f5f5f5;
  border-bottom: 1px solid #d9d9d9;
}

.response-code-section .section-title {
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5714285714285714em;
  color: rgba(0, 0, 0, 0.88);
}

.response-code-section .code-section-body {
  padding: 16px;
  background: #ffffff;
  font-family: 'Courier Prime', monospace;
  font-size: 12px;
  line-height: 1.33;
  overflow-x: auto;
  min-height: 180px;
}

.response-code-section .response-body {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
}

/* Send Request Button (default - for modal) */
.send-request-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 15px;
  height: 32px;
  background: #1677ff;
  border-color: #1677ff;
  border-radius: 6px;
  box-shadow: 0px 2px 0px 0px rgba(5, 145, 255, 0.1);
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 14px;
  font-weight: 500;
}

.send-request-button:hover {
  background: #4096ff !important;
  border-color: #4096ff !important;
}

/* Try it Button (for EndPointSection right column) */
.try-it-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 15px;
  height: 32px;
  background: #e6f4ff !important;
  border: 1px solid #e6f4ff !important;
  border-radius: 6px;
  box-shadow: none !important;
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5714285714285714em;
}

.try-it-button span:not(.anticon) {
  color: #1677ff !important;
}

.try-it-button .anticon {
  color: #1677ff !important;
  font-size: 16px;
}

.try-it-button:hover {
  background: #d6e9ff !important;
  border-color: #d6e9ff !important;
}

.try-it-button:hover span:not(.anticon) {
  color: #0958d9 !important;
}

.try-it-button:hover .anticon {
  color: #0958d9 !important;
}

.try-it-button:active {
  background: #c4ddff !important;
  border-color: #c4ddff !important;
}

/* Loading State */
.response-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
}

.loading-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #1677ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.response-loading .ant-typography {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

/* Error State */
.response-error {
  text-align: center;
  padding: 20px;
}

.response-error .ant-typography {
  font-size: 14px;
}

/* Response Section */
.response-section {
  margin-top: 0;
}

.response-status {
  margin-bottom: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ApiDocsViewer/ApiTestSection/responseCodeSection.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,kDAAkD;EAClD;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Response Code Section Styles */\n.response-code-section {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  background: #ffffff;\n  overflow: hidden;\n  flex: 1;\n}\n\n.response-code-section .code-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #f5f5f5;\n  border-bottom: 1px solid #d9d9d9;\n}\n\n.response-code-section .section-title {\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.5714285714285714em;\n  color: rgba(0, 0, 0, 0.88);\n}\n\n.response-code-section .code-section-body {\n  padding: 16px;\n  background: #ffffff;\n  font-family: 'Courier Prime', monospace;\n  font-size: 12px;\n  line-height: 1.33;\n  overflow-x: auto;\n  min-height: 180px;\n}\n\n.response-code-section .response-body {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 180px;\n}\n\n/* Send Request Button (default - for modal) */\n.send-request-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 15px;\n  height: 32px;\n  background: #1677ff;\n  border-color: #1677ff;\n  border-radius: 6px;\n  box-shadow: 0px 2px 0px 0px rgba(5, 145, 255, 0.1);\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.send-request-button:hover {\n  background: #4096ff !important;\n  border-color: #4096ff !important;\n}\n\n/* Try it Button (for EndPointSection right column) */\n.try-it-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 15px;\n  height: 32px;\n  background: #e6f4ff !important;\n  border: 1px solid #e6f4ff !important;\n  border-radius: 6px;\n  box-shadow: none !important;\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5714285714285714em;\n}\n\n.try-it-button span:not(.anticon) {\n  color: #1677ff !important;\n}\n\n.try-it-button .anticon {\n  color: #1677ff !important;\n  font-size: 16px;\n}\n\n.try-it-button:hover {\n  background: #d6e9ff !important;\n  border-color: #d6e9ff !important;\n}\n\n.try-it-button:hover span:not(.anticon) {\n  color: #0958d9 !important;\n}\n\n.try-it-button:hover .anticon {\n  color: #0958d9 !important;\n}\n\n.try-it-button:active {\n  background: #c4ddff !important;\n  border-color: #c4ddff !important;\n}\n\n/* Loading State */\n.response-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 20px;\n}\n\n.loading-spinner {\n  width: 24px;\n  height: 24px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #1677ff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.response-loading .ant-typography {\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n}\n\n/* Error State */\n.response-error {\n  text-align: center;\n  padding: 20px;\n}\n\n.response-error .ant-typography {\n  font-size: 14px;\n}\n\n/* Response Section */\n.response-section {\n  margin-top: 0;\n}\n\n.response-status {\n  margin-bottom: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
